const getSafety =
  (getFn: (...args: any[]) => any) =>
  (...args: any[]) => {
    let value;
    try {
      value = getFn(...args);
    } catch (error) {
      console.warn((error as Error).message);
    }
    return value;
  };

const setSafety =
  (setFn: (...args: any[]) => any) =>
  (...args: any[]) => {
    try {
      setFn(...args);
    } catch (error) {
      console.warn((error as Error).message);
    }
  };

export class BrowserStorage {
  static get(key: string) {
    return BrowserStorage.getLocalStorage(key);
  }

  static remove(key: string) {
    return BrowserStorage.removeLocalStorage(key);
  }

  static set(key: string, value: string) {
    BrowserStorage.setLocalStorage(key, value);
  }

  static setLocalStorage(key: string, value: string) {
    const set = (k: string, v: string) => localStorage.setItem(k, v);
    setSafety(set)(key, value);
  }

  static getLocalStorage(key: string): string | undefined {
    const get = (k: string) => localStorage.getItem(k);
    return getSafety(get)(key);
  }

  static removeLocalStorage(key: string): void {
    const remove = (k: string) => localStorage.removeItem(k);
    return getSafety(remove)(key);
  }
}
